export default __webpack_public_path__ + "ac3120306c5eaa2d03b3059325e463bb.png";